@for (row of $rows(); track row.kind) {
  <div class="collection">
    <span class="collection-label">{{ row.label }}</span>
    <wb-select class="collection-level" [items]="options" bindLabel="label" bindValue="value" bindDescription1="description" [clearable]="false" [searchable]="false" [readonly]="$readonly()" [ngModel]="row.enforcement" (ngModelChange)="onSelect(row.kind, $event)" />
  </div>
}
